import axios from 'axios';
import { TFunction } from 'i18next';

import { baseURL } from 'utils/API';

import { NamespacesList } from 'core/enums/common';

export const readFileAsArrayBuffer = (file: File) => {
	return new Promise((resolve: (value: any) => void, reject) => {
		const reader = new FileReader();

		reader.onload = (event) => {
			const arrayBuffer = event.target?.result as ArrayBuffer;
			resolve(arrayBuffer);
		};

		reader.onerror = (error) => {
			reject(error);
		};

		reader.readAsArrayBuffer(file);
	});
};

export const uploadFileToCloud = (cloudURL: string, binaryArray: any) => {
	const axiosConfig: Record<string, any> = {
		headers: { 'Content-Type': 'application/pdf', 'x-ms-blob-type': 'BlockBlob' },
		baseURL,
	};
	const instance = axios.create(axiosConfig);
	return instance.put(cloudURL, binaryArray);
};

export const uploadDocumentErrors = (
	translate: TFunction<NamespacesList.common, undefined, NamespacesList.common>
) => ({
	sameFile: {
		title: translate('errors.alreadyExistFileTitle'),
		description: translate('errors.alreadyExistFileDescription'),
	},
});
